import React from 'react';

const NewVector2 = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="31"
    viewBox="0 0 32 31"
    fill="none"
    {...props}
  >
    <path
      d="M7.1084 10.9082H14.4401"
      stroke="#0E3054"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.7085 15.7412H14.44"
      stroke="#0E3054"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.03149 7.00879H17.7668V16.7385"
      stroke="#0E3054"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.6444 13.5762C23.5662 7.92214 19.73 2.5913 14.0759 1.66946C8.42182 0.747624 3.09098 4.58387 2.16914 10.238C1.2473 15.892 5.08354 21.2229 10.7376 22.1447C16.3917 23.0666 21.7226 19.2303 22.6444 13.5762Z"
      stroke="#0E3054"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.2605 17.7695L29.9311 26.4401C30.6898 27.1988 30.6898 28.4292 29.9311 29.1879L29.81 29.309C29.0513 30.0677 27.8208 30.0677 27.0622 29.309L18.3916 20.6385"
      stroke="#0E3054"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default NewVector2;
